export default __webpack_public_path__ + "static/media/Balsamiq.5c4ad260.svg";